<template>
  <div>
    <div class="page-modal">
      <gs-modal
        v-loading="loading"
        v-model="visible"
        :before-close="beforeClose"
        :before-confirm="beforeConfirm"
        title="项目"
        :has-form="true"
        class="my-test-class"
        width="50%"
        @close="close"
        @confirm="handleConfirm"
      >
        <div class="page-form">
          <gs-tabs
            v-model="activeName"
            type="content-tab"
          >
            <gs-tab-pane
              label="创建项目"
              name="first"
            >
              <gs-form
                ref="form"
                class="form"
                label-width="95px"
                label-position="left"
                gap="small"
              >
                <gs-form-item
                  label="名称:"
                  prop="name"
                  class="form-item-name"
                >
                  <gs-input
                    v-model="name"
                    type="text"
                  />
                </gs-form-item>
                <gs-form-item
                  label="项目基础信息:"
                  prop="describe"
                  class="form-item-name"
                >
                  <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="请输入内容"
                    v-model="textarea"
                  >
                  </el-input>
                </gs-form-item>
                <gs-form-item
                  label="项目类型:"
                  prop="describe"
                  class="form-item-name"
                >
                  <el-radio
                    v-model="radio"
                    label="1"
                  >智慧楼宇</el-radio>
                  <el-radio
                    v-model="radio"
                    label="2"
                  >智慧园区</el-radio>
                  <el-radio
                    v-model="radio"
                    label="3"
                  >智慧工地</el-radio>
                  <el-radio
                    v-model="radio"
                    label="4"
                  >数字园区</el-radio>
                  <el-radio
                    v-model="radio"
                    label="5"
                  >智慧场馆</el-radio>
                  <el-radio
                    v-model="radio"
                    label="6"
                  >智慧医院</el-radio>
                  <el-radio
                    v-model="radio"
                    label="7"
                  >市政设施</el-radio>
                  <el-radio
                    v-model="radio"
                    label="8"
                  >智慧交通</el-radio>
                  <el-radio
                    v-model="radio"
                    label="9"
                  >环保监测</el-radio>
                  <el-radio
                    v-model="radio"
                    label="10"
                  >其他</el-radio>
                </gs-form-item>
                <!--  <gs-form-item
                    label="选择:"
                    prop="describe"
                    class="form-item-name"
                  >
                    <el-checkbox-group v-model="form.type">
                      <el-checkbox label="美食/餐厅线上活动" name="type"></el-checkbox>
                      <el-checkbox label="地推活动" name="type"></el-checkbox>
                      <el-checkbox label="线下主题活动" name="type"></el-checkbox>
                      <el-checkbox label="单纯品牌曝光" name="type"></el-checkbox>
                    </el-checkbox-group>
                  </gs-form-item>-->
              </gs-form>
            </gs-tab-pane>
            <gs-tab-pane
              label="已有项目"
              name="last"
            >

              <div>
                <span>对象列表：</span>
                <div class="form-item-objectSeries">
                  <gs-table
                    ref="objTable"
                    :data="objectData"
                  >
                    <gs-table-column type="selection" />
                    <gs-table-column
                      :show-overflow-tooltip="true"
                      prop="name"
                      label="名称"
                      data-align="right"
                      width=""
                    />
                    <gs-table-column
                      :show-overflow-tooltip="true"
                      prop="type"
                      label="描述"
                      width=""
                    />
                    <gs-table-column
                      :show-overflow-tooltip="true"
                      prop="name"
                      label="时间"
                      width=""
                    />
                  </gs-table>
                </div>
              </div>

            </gs-tab-pane>
          </gs-tabs>
        </div>
      </gs-modal>
      <div class="model-tool">
        <el-dialog
          title="其他信息"
          :visible.sync="dialogVisible"
          width="50%"
          :before-close="handleClose"
        >
          <span
            slot="footer"
            class="dialog-footer"
          >
            <div style="width: 100%;height: 500px;background-color: #fff9fb"> </div>
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button
              type="primary"
              @click="dialogVisible = false"
            >确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { mapState, mapMutations } from 'vuex'
import service from '../../service/leftService.js'
export default {
  components: {

  },
  data() {
    return {
      objectData: [{
        name: '项目1',
        type: '项目1的描述信息',
        time: '2020-2-9'
      }, {
        name: '项目3',
        type: '项目1的描述信息',
        time: '2020-2-9'
      }, {
        name: '项目4',
        type: '项目1的描述信息',
        time: '2020-2-9'
      }, {
        name: '项目5',
        type: '项目1的描述信息',
        time: '2020-2-9'
      }],
      activeName: 'first',
      textarea: '',
      loading: false,
      describe: '',
      name: '',
      radio: '1',
      form: {
        type: [],
        date1: '',
        date2: '',
        startTime: '',
      },
      dialogVisible: false,
    }
  },
  computed: {
    ...mapState({
      visible: 'addFolderDesginDialog',
      nodeData: 'objectInfo'
    }),
    typeName() {
      let type = this.$store.state.type
      switch (type) {
        case 'project':
          return '项目'
        case 'folder':
          return '文件夹'
        case 'server':
          return '服务器'
        case 'logicalGroup':
          return '逻辑组'
        case 'deviceGroup':
          return '设备组'
        default:
          break
      }
    }
  },
  watch: {
    visible() {
      if (this.visible) {
        this.name = ''
        setTimeout(() => {
          this.$refs.nameInput.focus()
        }, 100)
      }
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    ...mapMutations({
      close: 'FOLDER_DESGIN_HIDE',
      needReload: 'NEED_RELOAD_TREE'
    }),
    handleClose() {
      this.dialogVisible = false
    },
    beforeClose() {
      this.close()
    },
    beforeConfirm(e, done) {
      if (this.name === null || this.name === '') {
        this.$Message.warning('名称不能为空!')
        return
      }
      // done(false)可以阻止modal关闭
      done()
    },
    handleConfirm() {
      this.loading = true
      let data = {
        attribute: null,
        children: [],
        description: '',
        name: this.name,
        parentId: this.nodeData.id,
        type: this.$store.state.type
      }
      service.designSaveNode(data).then(res => {
        this.name = ''
        this.loading = false
        this.$Message.success('新建成功')
        this.close()
        this.$store.state.addTreeNode = res
      }).catch(err => {
        this.loading = false
        this.$Message.error(err.message)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/left-side/addFolder-desgin.vue